"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t,
    n = (e = require("eventemitter3")) && "object" == typeof e && "default" in e ? e.default : e,
    E = require("react");

function r() {
  return (r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var E in n) {
        Object.prototype.hasOwnProperty.call(n, E) && (e[E] = n[E]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function o() {
  return "undefined" == typeof window ? new n() : (window._emitter || (window._emitter = new n()), window._emitter);
}

function s(e) {
  return function (e, t) {
    o().addListener(String(e), function (e) {
      t(e);
    });
  };
}

(t = exports.Events || (exports.Events = {}))[t.COOKIES_ACCEPTED = 0] = "COOKIES_ACCEPTED", t[t.SESSION_DESTROYED = 1] = "SESSION_DESTROYED", t[t.PAGE_VIEW = 2] = "PAGE_VIEW", t[t.AUTHENTICATION_REQUIRED = 3] = "AUTHENTICATION_REQUIRED", t[t.INVALID_LOGIN_CODE = 4] = "INVALID_LOGIN_CODE", t[t.TOO_MANY_INVALID_LOGIN_ATTEMPTS = 5] = "TOO_MANY_INVALID_LOGIN_ATTEMPTS", t[t.SUCCESSFULLY_LOGGED_IN = 6] = "SUCCESSFULLY_LOGGED_IN", t[t.LOGIN_CODE_SENT = 7] = "LOGIN_CODE_SENT", t[t.EMAIL_VERIFIED = 8] = "EMAIL_VERIFIED", t[t.TERMS_ACCEPTED = 9] = "TERMS_ACCEPTED", t[t.PLAYER_DETAILS_SUBMITTED = 10] = "PLAYER_DETAILS_SUBMITTED", t[t.LOGOUT = 11] = "LOGOUT", t[t.DEPOSIT = 12] = "DEPOSIT", t[t.SERVICE_WORKER_UPDATED_EVENT = 13] = "SERVICE_WORKER_UPDATED_EVENT", t[t.GAME_LAUNCHED = 14] = "GAME_LAUNCHED", t[t.GAME_CLOSED = 15] = "GAME_CLOSED", t[t.LOGIN_ATTEMPT_FROM_FORBIDDEN_COUNTRY = 16] = "LOGIN_ATTEMPT_FROM_FORBIDDEN_COUNTRY", t[t.LOGIN_ATTEMPT_FROM_UNSAFE_CONNECTION = 17] = "LOGIN_ATTEMPT_FROM_UNSAFE_CONNECTION", t[t.HIDE_REALITY_CHECK_EVENT = 18] = "HIDE_REALITY_CHECK_EVENT", t[t.SHOW_REALITY_CHECK_EVENT = 19] = "SHOW_REALITY_CHECK_EVENT", t[t.ACCESS_TOKEN_UPDATED_EVENT = 20] = "ACCESS_TOKEN_UPDATED_EVENT", exports.accessTokenUpdatedEvent = function (e) {
  return function (t) {
    return {
      event: exports.Events.ACCESS_TOKEN_UPDATED_EVENT,
      accessToken: e,
      path: t.path
    };
  };
}, exports.authenticationRequiredEvent = function (e) {
  return {
    event: exports.Events.AUTHENTICATION_REQUIRED,
    path: e.path
  };
}, exports.cookiesAcceptedEvent = function (e) {
  return {
    event: exports.Events.COOKIES_ACCEPTED,
    path: e.path
  };
}, exports.depositEvent = function (e, t, n, E) {
  return function () {
    return {
      event: exports.Events.DEPOSIT,
      status: e,
      reference: E,
      currency: n,
      amount: t
    };
  };
}, exports.emailVerifiedEvent = function (e) {
  return {
    event: exports.Events.EMAIL_VERIFIED,
    path: e.path
  };
}, exports.gameClosedEvent = function (e) {
  return {
    event: exports.Events.GAME_CLOSED,
    path: e.path
  };
}, exports.gameLaunchedEvent = function (e, t) {
  return function (n) {
    return {
      event: exports.Events.GAME_LAUNCHED,
      launchId: e,
      isLoggedIn: t,
      path: n.path
    };
  };
}, exports.globalEmitter = o, exports.hideRealityCheckEvent = function () {
  return function (e) {
    return {
      event: exports.Events.HIDE_REALITY_CHECK_EVENT,
      path: e.path
    };
  };
}, exports.installAnalytics = function (e, t) {
  var n = s(),
      E = function E() {
    var e;
    (e = window).ga.apply(e, arguments);
  };

  E("create", e, t), "function" == typeof navigator.sendBeacon ? E("set", "transport", "beacon") : E("set", "transport", "xhr"), n(exports.Events.PAGE_VIEW, function (e) {
    E("set", "page", e.path), E("send", "pageview");
  }), n(exports.Events.AUTHENTICATION_REQUIRED, function (e) {
    E("send", "event", "Errors", "Not Logged In", e.path);
  }), n(exports.Events.TOO_MANY_INVALID_LOGIN_ATTEMPTS, function (e) {
    E("send", "event", "Errors", "Too Many Invalid Login Attempts", e.path);
  }), n(exports.Events.INVALID_LOGIN_CODE, function (e) {
    E("send", "event", "Errors", "Invalid Login Code", e.path);
  }), n(exports.Events.TERMS_ACCEPTED, function (e) {
    E("send", "event", "Player", "Terms Accepted", e.path);
  }), n(exports.Events.PLAYER_DETAILS_SUBMITTED, function (e) {
    E("send", "event", "Player", "Player Details Submitted", e.path);
  }), n(exports.Events.EMAIL_VERIFIED, function (e) {
    E("send", "event", "Player", "Email Verified", e.path);
  }), n(exports.Events.LOGIN_ATTEMPT_FROM_FORBIDDEN_COUNTRY, function (e) {
    E("send", "event", "Sessions", "Login Attempt From Forbidden Country", e.path);
  }), n(exports.Events.LOGIN_ATTEMPT_FROM_UNSAFE_CONNECTION, function (e) {
    E("send", "event", "Sessions", "Login Attempt From Unsafe Connection", e.path);
  }), n(exports.Events.LOGIN_CODE_SENT, function (e) {
    E("send", "event", "Sessions", "Login Code Sent", e.phoneNumber);
  }), n(exports.Events.GAME_LAUNCHED, function (e) {
    E("send", "event", "Game", e.isLoggedIn ? "Real Game Launched" : "Demo Game Launched", e.launchId);
  }), n(exports.Events.LOGOUT, function (e) {
    E("send", "event", "Sessions", "Logout", e.reason);
  }), n(exports.Events.DEPOSIT, function (e) {
    var t = e.status;
    E("send", "event", "Deposits", "SUCCESSFUL" === t ? "Deposit" : "Failed Deposit", t, +e.amount, {
      dimension1: e.currency
    });
  });
}, exports.installer = s, exports.invalidLoginCodeEvent = function (e) {
  return {
    event: exports.Events.INVALID_LOGIN_CODE,
    path: e.path
  };
}, exports.loginAttemptFromForbiddenCountryEvent = function (e) {
  return {
    event: exports.Events.LOGIN_ATTEMPT_FROM_FORBIDDEN_COUNTRY,
    path: e.path
  };
}, exports.loginAttemptFromUnsafeConnectionEvent = function (e) {
  return {
    event: exports.Events.LOGIN_ATTEMPT_FROM_UNSAFE_CONNECTION,
    path: e.path
  };
}, exports.loginCodeSentEvent = function (e) {
  return function (t) {
    return {
      event: exports.Events.LOGIN_CODE_SENT,
      phoneNumber: e,
      path: t.path
    };
  };
}, exports.logoutEvent = function (e, t) {
  return function (n) {
    return {
      event: exports.Events.LOGOUT,
      reason: e,
      path: n.path,
      exitPath: t
    };
  };
}, exports.pageViewEvent = function (e) {
  return function (t) {
    return {
      event: exports.Events.PAGE_VIEW,
      path: e || t.path
    };
  };
}, exports.playerDetailsSubmittedEvent = function (e) {
  return {
    event: exports.Events.PLAYER_DETAILS_SUBMITTED,
    path: e.path
  };
}, exports.serviceWorkerUpdatedEvent = function () {
  return function (e) {
    return {
      event: exports.Events.SERVICE_WORKER_UPDATED_EVENT,
      path: e.path
    };
  };
}, exports.sessionDestroyedEvent = function (e) {
  return {
    event: exports.Events.SESSION_DESTROYED,
    path: e.path
  };
}, exports.showRealityCheckEvent = function () {
  return function (e) {
    return {
      event: exports.Events.SHOW_REALITY_CHECK_EVENT,
      path: e.path
    };
  };
}, exports.successfullyLoggedInEvent = function (e) {
  return {
    event: exports.Events.SUCCESSFULLY_LOGGED_IN,
    path: e.path
  };
}, exports.termsAcceptedEvent = function (e) {
  return {
    event: exports.Events.TERMS_ACCEPTED,
    path: e.path
  };
}, exports.tooManyInvalidLoginAttemptsEvent = function (e) {
  return {
    event: exports.Events.TOO_MANY_INVALID_LOGIN_ATTEMPTS,
    path: e.path
  };
}, exports.trigger = function (e, t) {
  void 0 === t && (t = {});

  var n = e({
    path: window.location.pathname + window.location.search
  }),
      E = n.event,
      s = function (e, t) {
    if (null == e) return {};
    var n,
        E,
        r = {},
        o = Object.keys(e);

    for (E = 0; E < o.length; E++) {
      t.indexOf(n = o[E]) >= 0 || (r[n] = e[n]);
    }

    return r;
  }(n, ["event"]);

  o().emit(E, r(r({}, s), t));
}, exports.useEventListener = function (e, t) {
  var n = E.useRef();
  E.useLayoutEffect(function () {
    n.current = t;
  }, [t]), E.useLayoutEffect(function () {
    var t = o();

    if (t) {
      var E = function E(e) {
        return n.current && n.current(e);
      };

      return t.on(e, E), function () {
        t.removeListener(e, E);
      };
    }
  }, [e]);
};